import React from 'react';
import FormSelect from '../../components/FormSelect';

export const SortBySelect = (props) => (
    <FormSelect
      {...props}
      id="apis-sort-by"
      data-apim-test="apis-sort-by"
      noNoneOption
      noNativeSelect
    />
);